import { useMutation } from "urql";

import { RejectTransactionHistoryDocument } from "../../../graphql/generated.ts";

export const useRejectTransactionHistory = () =>
  useMutation(RejectTransactionHistoryDocument);
